type PrefabVariant = {
    options?: Record<string, unknown>;
    children?: unknown[];
};

export type CustomPrefabs = Record<
    string,
    {
        defaultVariant?: string;
        /** When false, a menu item in a column variant stays a column. The steps setting replaces this. */
        menuUsesSteps?: boolean;
        prefabs?: Record<string, PrefabVariant>;
        addToCartAction?: 'addToCart' | 'viewDetail' | 'selectVenue';
    }
>;

export type ProductDetailOpenMode = 'modal' | 'page';

export type ProductDetailStepsMode = 'never' | 'menu' | 'always';

export type ProductDetailSettings = {
    openMode?: ProductDetailOpenMode;
    /** never = column, menu = steps only for a menu item, always = steps for every item. */
    stepsMode?: ProductDetailStepsMode;
};

export type ProductTagsPlacement = 'belowImage' | 'overImage';
export type ProductTagsAppearance = 'outline' | 'fill';

export type ProductTagsSettings = {
    placement?: ProductTagsPlacement;
    appearance?: ProductTagsAppearance;
};

export const prefabsStore = (() => {
    let prefabs: CustomPrefabs | null = null;
    let templatePrefabs: CustomPrefabs | null = null;
    let productDetail: ProductDetailSettings | null = null;
    let productTags: ProductTagsSettings | null = null;

    return {
        getPrefabs: (): CustomPrefabs | null => prefabs,
        setPrefabs: (p: CustomPrefabs) => {
            prefabs = p;
        },
        getTemplatePrefabs: (): CustomPrefabs | null => templatePrefabs,
        setTemplatePrefabs: (p: CustomPrefabs | null) => {
            templatePrefabs = p;
        },
        getProductDetail: (): ProductDetailSettings | null => productDetail,
        setProductDetail: (p: ProductDetailSettings | null) => {
            productDetail = p;
        },
        getProductTags: (): ProductTagsSettings | null => productTags,
        setProductTags: (p: ProductTagsSettings | null) => {
            productTags = p;
        },
    };
})();
